import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { INoteableTypes } from 'types/graphqlTypes'
import Notes from 'apps/marketplace/components/Notes'

interface IStrategyNotesTabProps {
  strategyId: string | null
}

export const StrategyNotesTab: FC<IStrategyNotesTabProps> = ({ strategyId }) => {
  return (
    <Box ml={3} mr={3}>
      {strategyId && (
        <Notes
          noteableId={strategyId}
          noteableType={INoteableTypes.RequestForProposalStrategy}
          inputLocation='bottom'
          disableHeader
          disableFilters
          disableBorder
          disableCallback
        />
      )}
    </Box>
  )
}
